import { SignalsPayload } from "@timeedit/registration-schemas";
import { Typography } from "@timeedit/ui-components";
import { useContext } from "react";
import { SignalSummary } from "../SignalSummary";
import { RegistrationContext, UtilContext } from "./RegistrationContexts";
import { RegistrationOptionsContext } from "./RegistrationOptions";

interface RegistrationHeaderProps {
  signal: SignalsPayload;
}

export function RegistrationHeader({
  signal,
}: RegistrationHeaderProps): React.JSX.Element {
  const { translations } = useContext(UtilContext);
  const { registration, mode } = useContext(RegistrationContext);
  const { headingLevel } = useContext(RegistrationOptionsContext);

  return (
    <div className="registration-page__header">
      <Typography.Title
        level={3}
        semanticLevel={mode === "student" ? headingLevel(1) : undefined}
        className="registration-page__title"
      >
        {translations.registration}
        <br />
      </Typography.Title>
      <div className="registration-page__status-container">
        <SignalSummary
          signal={signal}
          translations={translations}
          conflicts={registration.conflicts}
        />
      </div>
    </div>
  );
}
